export enum SALE_FORMAT_STEP {
  initial = 'initial',
  selectAddons = 'selectAddons',
  onlyAddons = 'onlyAddons',
  productWithAddons = 'productWithAddons',
  addAddons = 'addAddons',
  addProductAddons = 'addProductAddons',
  noRenderedStep = 'noRenderedStep',
}
